import { render } from "./HardwareInfoAction.vue?vue&type=template&id=c6c12d90&ts=true"
import script from "./HardwareInfoAction.vue?vue&type=script&lang=ts"
export * from "./HardwareInfoAction.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__